export const SET_CSAT_INFO = "SET-CSAT-INFO";
export const GET_CSAT_INFO = "GET-CSAT-INFO";
export const CHANGE_DISTRIBUTION = "CHANGE-DISTRIBUTION";
export const CHANGE_SNIPPET_TEXT = "CHANGE-SNIPPET-TEXT";
export const CHANGE_COMMENT_TEXT = "CHANGE-COMMENT-TEXT";
export const CHANGE_SUBMIT_TEXT = "CHANGE-SUBMIT-TEXT";
export const CHANGE_THANKYOU_TEXT = "CHANGE-THANKYOU-TEXT";
export const CHANGE_SNIPPET_TYPE = "CHANGE-SNIPPET-TYPE";
export const CHANGE_CSAT_TEXT_RATINGS = "CHANGE-CSAT-TEXT-RATINGS";
export const CHANGE_CSAT_ORDERING = "CHANGE-CSAT-ORDERING";
export const SET_LAST_UPDATE = "SET-LAST-UPDATE";
export const UNSAVED_CHANGES_STATE = "UNSAVED-CHANGES-STATE";
export const CHANGE_SEND_SURVEY = "CHANGE-SEND-SURVEY";
export const CHANGE_EXCLUDE_DOMAIN = "CHANGE-EXCLUDE-DOMAIN";
export const CHANGE_IS_BLOCKED_DOMAINS_ENABLED = "CHANGE_IS_BLOCKED_DOMAINS_ENABLED";

